// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mounted as a child inside pipeline-sandbox's own view container (a flex
   column) — fill it, rather than rendering our own fixed-position overlay.
   Reuses .ps-detail-header/.btn/.ps-input from pipeline-sandbox.css and
   .mlw-param-label/.mlw-param-note/.mlw-error-row/.mlw-placeholder from
   ml-panel-shared.css — this file only adds table/detail layout specific to Model
   Management. */
:host {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.mlm-table-wrap {
    flex: 1;
    overflow: auto;
    padding: 0 16px 16px;
}

.mlm-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}

.mlm-table th {
    text-align: left;
    padding: 6px 8px;
    border-bottom: 2px solid var(--border-color, #ddd);
    color: var(--text-secondary, #666);
    font-weight: 600;
}

.mlm-table td {
    padding: 6px 8px;
    border-bottom: 1px solid var(--border-color, #eee);
}

.mlm-table tr.mlm-row-clickable {
    cursor: pointer;
}

.mlm-table tr.mlm-row-clickable:hover {
    background: var(--bg-hover, #f5f5f5);
}

.mlm-table tr.mlm-row-selected {
    background: rgba(0, 102, 204, 0.08);
}

.mlm-state-badge {
    display: inline-block;
    padding: 1px 7px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    background: var(--bg-secondary, #eee);
    color: var(--text-secondary, #555);
}

.mlm-state-badge.promoted { background: #d4edda; color: #155724; }
.mlm-state-badge.trained { background: #d1ecf1; color: #0c5460; }
.mlm-state-badge.training { background: #fff3cd; color: #856404; }
.mlm-state-badge.retired { background: #e2e3e5; color: #383d41; }

.mlm-detail-body {
    flex: 1;
    display: flex;
    gap: 16px;
    overflow: hidden;
    padding: 0 16px 16px;
}

.mlm-detail-col {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.mlm-actions-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0 14px;
    flex-wrap: wrap;
}

.mlm-section {
    margin-bottom: 18px;
}

.mlm-section-title {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 6px;
}

.mlm-kv-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
    padding: 3px 0;
    border-bottom: 1px solid var(--border-color, #f0f0f0);
}

.mlm-chart-container {
    width: 100%;
    height: 200px;
}

.mlm-training-form {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/ml-models.css"],"names":[],"mappings":"AAEA;;;;;gBAKgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kDAAkD;IAClD,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE;IACI,OAAO;IACP,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,cAAc;IACd,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":["@import url(\"./global.css\");\n\n/* Mounted as a child inside pipeline-sandbox's own view container (a flex\n   column) — fill it, rather than rendering our own fixed-position overlay.\n   Reuses .ps-detail-header/.btn/.ps-input from pipeline-sandbox.css and\n   .mlw-param-label/.mlw-param-note/.mlw-error-row/.mlw-placeholder from\n   ml-panel-shared.css — this file only adds table/detail layout specific to Model\n   Management. */\n:host {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.mlm-table-wrap {\n    flex: 1;\n    overflow: auto;\n    padding: 0 16px 16px;\n}\n\n.mlm-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n}\n\n.mlm-table th {\n    text-align: left;\n    padding: 6px 8px;\n    border-bottom: 2px solid var(--border-color, #ddd);\n    color: var(--text-secondary, #666);\n    font-weight: 600;\n}\n\n.mlm-table td {\n    padding: 6px 8px;\n    border-bottom: 1px solid var(--border-color, #eee);\n}\n\n.mlm-table tr.mlm-row-clickable {\n    cursor: pointer;\n}\n\n.mlm-table tr.mlm-row-clickable:hover {\n    background: var(--bg-hover, #f5f5f5);\n}\n\n.mlm-table tr.mlm-row-selected {\n    background: rgba(0, 102, 204, 0.08);\n}\n\n.mlm-state-badge {\n    display: inline-block;\n    padding: 1px 7px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 600;\n    text-transform: uppercase;\n    background: var(--bg-secondary, #eee);\n    color: var(--text-secondary, #555);\n}\n\n.mlm-state-badge.promoted { background: #d4edda; color: #155724; }\n.mlm-state-badge.trained { background: #d1ecf1; color: #0c5460; }\n.mlm-state-badge.training { background: #fff3cd; color: #856404; }\n.mlm-state-badge.retired { background: #e2e3e5; color: #383d41; }\n\n.mlm-detail-body {\n    flex: 1;\n    display: flex;\n    gap: 16px;\n    overflow: hidden;\n    padding: 0 16px 16px;\n}\n\n.mlm-detail-col {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n}\n\n.mlm-actions-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 8px 0 14px;\n    flex-wrap: wrap;\n}\n\n.mlm-section {\n    margin-bottom: 18px;\n}\n\n.mlm-section-title {\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 6px;\n}\n\n.mlm-kv-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 12px;\n    padding: 3px 0;\n    border-bottom: 1px solid var(--border-color, #f0f0f0);\n}\n\n.mlm-chart-container {\n    width: 100%;\n    height: 200px;\n}\n\n.mlm-training-form {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
